import React, { Fragment } from "react";
import {
  ShimmerThumbnail,
  ShimmerButton,
  ShimmerTitle,
} from "react-shimmer-effects";
import "./Productview.css";
import "./ProductDetail.css";

export default function ProductMainShimmer() {
  return (
    <Fragment>
      <div className="dp-page dp-page--embedded dp-shimmer">
        <div className="dp-page__inner">
          <div className="dp-topbar">
            <ShimmerButton size="md" />
            <ShimmerButton size="sm" />
          </div>
          <div className="dp-hero">
            <div className="dp-panel">
              <ShimmerThumbnail className="w-100" height={360} />
              <div className="dp-panel__body">
                <ShimmerTitle line={2} gap={10} variant="primary" />
              </div>
            </div>
            <div className="dp-panel">
              <div className="dp-panel__body">
                <ShimmerTitle line={3} gap={12} variant="primary" />
                <div style={{ marginTop: "1rem" }}>
                  <ShimmerThumbnail height={160} />
                </div>
                <div style={{ marginTop: "1rem" }}>
                  <ShimmerThumbnail height={120} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
